import { LiteratureFilter } from '../types';
import api from './api.ts';

export const processService = {
    async getProcessingStatus(projectId: number) {
        const response = await api.get(`/literature/process-status/${projectId}`);
        return response.data;
    },

    async processLiterature(data: { reviewer_id: number; lit_filter: LiteratureFilter }) {
        const response = await api.post('/literature/process', data);
        return response.data;
    },

    async retrieveFullTexts(lit_filter: LiteratureFilter) {
        const response = await api.post('/literature/retrieve-full-texts', lit_filter);
        return response.data;
    },
};
